import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { 
  TrophyOutlined, 
  GiftOutlined, 
  SwapOutlined 
} from '@ant-design/icons';
import { PageLayout } from '../../components/layout/PageLayout';

const AdminDashboard: React.FC = () => {
  const adminFeatures = [
    {
      title: 'Gestion des Missions',
      description: 'Créer et gérer les missions pour les joueurs',
      icon: <TrophyOutlined className="text-4xl mb-4 text-blue-500" />,
      link: '/admin/missions'
    },
    {
      title: 'Gestion des Récompenses',
      description: 'Gérer les récompenses disponibles pour les missions',
      icon: <GiftOutlined className="text-4xl mb-4 text-green-500" />,
      link: '/admin/rewards'
    },
    {
      title: 'Paramètres des Échanges',
      description: 'Configurer les règles et paramètres des échanges',
      icon: <SwapOutlined className="text-4xl mb-4 text-purple-500" />,
      link: '/admin/trading-settings'
    }
  ];

  return (
    <PageLayout disableAds={true}>
      <div className="p-6">
        <h1 className="text-2xl font-bold mb-6">Tableau de Bord Administrateur</h1>
        
        <Row gutter={[16, 16]}>
          {adminFeatures.map((feature, index) => (
            <Col xs={24} sm={12} lg={8} key={index}>
              <Link to={feature.link}>
                <Card 
                  hoverable 
                  className="h-full text-center transition-transform hover:scale-105"
                >
                  {feature.icon}
                  <h2 className="text-xl font-semibold mb-2">{feature.title}</h2>
                  <p className="text-gray-600">{feature.description}</p>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </PageLayout>
  );
};

export default AdminDashboard; 